import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { cn } from "utils/helpers";
import type { CriteriaId, CriteriaListItem } from "../../types/meeting.type";

interface CriteriaNavProps {
  criteriaList: CriteriaListItem[];
  currentCriteriaId: CriteriaId;
  goNext: () => void;
  goPrev: () => void;
  goTo: (id: CriteriaId) => void;
}

export const CriteriaNav: React.FC<CriteriaNavProps> = ({
  currentCriteriaId,
  criteriaList,
  goNext,
  goPrev,
  goTo,
}) => {
  const isFirst =
    criteriaList.length > 0 && currentCriteriaId === criteriaList[0].id;
  const isOverall = currentCriteriaId === "overall";

  return (
    <div className="flex items-center gap-2 px-4 py-3 bg-white border-b border-gray-200" data-testid="criteria-nav">
      <button
        onClick={goPrev}
        disabled={isFirst}
        className={cn(
          "p-1.5 rounded hover:bg-gray-100 transition-colors",
          isFirst && "opacity-40 cursor-not-allowed"
        )}
        aria-label="Previous criterion"
      >
        <FiChevronLeft className="w-4 h-4" />
      </button>

      <div className="flex-1 flex items-center gap-1 overflow-x-auto scrollbar-hide">
        {criteriaList.map((item) => (
          <button
            key={item.id}
            onClick={() => goTo(item.id)}
            className={cn(
              "flex-shrink-0 px-3 py-1 rounded-full text-xs font-medium transition-colors",
              currentCriteriaId === item.id
                ? "bg-blue-600 text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200",
              item.is_complete && currentCriteriaId !== item.id && "bg-green-100 text-green-700 hover:bg-green-200"
            )}
          >
            {item.name}
          </button>
        ))}
        <button
          onClick={() => goTo("overall")}
          className={cn(
            "flex-shrink-0 px-3 py-1 rounded-full text-xs font-medium transition-colors",
            isOverall
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          )}
        >
          Scores and Award
        </button>
      </div>

      <button
        onClick={goNext}
        disabled={isOverall}
        className={cn(
          "p-1.5 rounded hover:bg-gray-100 transition-colors",
          isOverall && "opacity-40 cursor-not-allowed"
        )}
        aria-label="Next criterion"
      >
        <FiChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};
